import React from "react";
import { Activity } from "lucide-react";

export function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-center text-muted-foreground">
      <Activity className="h-8 w-8 opacity-30" />
      <p className="text-sm font-medium">No events yet</p>
      <p className="text-xs max-w-[22ch]">
        Events appear here as Mycelium processes tasks, AI calls, and
        notifications.
      </p>
    </div>
  );
}
